import i18n from 'i18next';

export function createOptionsTuples(values, { i18nKey }) {
  return values.map((value) => ({
    value,
    label: i18n.t(`${i18nKey}.${value}`),
  }));
}
